module.exports = __webpack_public_path__ + "img/logo-control-room.72f0a013.png";